import { render, staticRenderFns } from "./controlVariationItem.vue?vue&type=template&id=5c68aa4c&scoped=true&"
import script from "./controlVariationItem.vue?vue&type=script&lang=js&"
export * from "./controlVariationItem.vue?vue&type=script&lang=js&"
import style0 from "./controlVariationItem.vue?vue&type=style&index=0&id=5c68aa4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c68aa4c",
  null
  
)

export default component.exports